import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CategoryEdition, CreateCategoryPayload, PermitCategory, UpdateCategoryPayload } from '../models/permit-category.model';
import { CreatePermitTypePayload, PermitTypeConfig, PermitTypeSearchResult, UpdatePermitTypePayload } from '../models/permit-type.model';

@Injectable()
export class PermitCategoryService {
    private readonly baseUrl = `${environment.API_GATEWAY_URL}/permit/admin/permit-category`;

    constructor(private http: HttpClient) {}

    getCategories(): Observable<PermitCategory[]> {
        return this.http.get<PermitCategory[]>(this.baseUrl);
    }

    getCategoryEdition(id: string): Observable<CategoryEdition> {
        return this.http.get<CategoryEdition>(`${this.baseUrl}/${id}/edition`);
    }

    createCategory(payload: CreateCategoryPayload): Observable<PermitCategory> {
        return this.http.post<PermitCategory>(this.baseUrl, payload);
    }

    updateCategory(id: string, payload: UpdateCategoryPayload): Observable<PermitCategory> {
        return this.http.patch<PermitCategory>(`${this.baseUrl}/${id}`, payload);
    }

    deleteCategory(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }

    // Permit type search (across categories)
    searchPermitTypes(search?: string, categoryId?: string): Observable<PermitTypeSearchResult[]> {
        let params = new HttpParams();
        if (search) params = params.set('search', search);
        if (categoryId) params = params.set('categoryId', categoryId);
        return this.http.get<PermitTypeSearchResult[]>(`${this.baseUrl}/subject/search`, { params });
    }

    searchPermitTypesUntranslated(search?: string, categoryId?: string): Observable<PermitTypeSearchResult[]> {
        let params = new HttpParams();
        if (search) params = params.set('search', search);
        if (categoryId) params = params.set('categoryId', categoryId);
        return this.http.get<PermitTypeSearchResult[]>(`${this.baseUrl}/subject/search/untranslated`, { params });
    }

    // Permit types (nested under category)
    createPermitType(categoryId: string, payload: CreatePermitTypePayload): Observable<PermitTypeConfig> {
        return this.http.post<PermitTypeConfig>(`${this.baseUrl}/${categoryId}/permit-type`, payload);
    }

    updatePermitType(categoryId: string, typeId: string, payload: UpdatePermitTypePayload): Observable<PermitTypeConfig> {
        return this.http.patch<PermitTypeConfig>(`${this.baseUrl}/${categoryId}/permit-type/${typeId}`, payload);
    }

    deletePermitType(categoryId: string, typeId: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${categoryId}/permit-type/${typeId}`);
    }
}
